export const mediaQueries = {
    desktop: "@media all and (min-width: 1051px)",
    mobile: "@media all and (max-width: 1050px)",
};
//# sourceMappingURL=mediaQueries.js.map